import React, { memo, useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { FONT, THEME, __WEB__ } from '../../../constants/styles';
import { PROVIDER_NUMS_AVAILABLE_KEYS } from '../selector';
import moment from 'moment';

const renderHoverOverListItem = (time, i) => {
  return (
    <View style={THEME.basicRow} key={`${time}_${i}`}>
      <Text style={{ fontFamily: 'sans-serif', color: 'white' }} pointerEvents="none">
        {time}
      </Text>
    </View>
  );
};
const HoverOverView = (props) => {
  if (!props.availableTimes?.length) return null;
  const sortedTimes = useMemo(() => {
    return props.availableTimes.sort((a, b) => a.localeCompare(b));
  }, [props.availableTimes]);

  let top = props.top - 257 - 100;
  let left = props.top - 840;

  top = Math.max(Math.min(top, 480), 20);
  left = Math.max(Math.min(left, 355), 20);
  const posStyle = { top, left };
  return (
    <View pointerEvents="none" style={[styles.container, posStyle]}>
      <Text style={styles.hoverOverItemText}>Available Times:</Text>
      <View style={styles.listContainer}>{sortedTimes.map(renderHoverOverListItem)}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    minWidth: 100,
    minHeight: 50,
    backgroundColor: 'rgba(22, 33, 54, .8)',
    borderRadius: 10,
    padding: 15,
  },
  listContainer: {
    alignItems: 'flex-start',
    paddingTop: 5,
  },
  hoverOverItemText: {
    ...FONT.medium,
    color: '#fefefe',
    fontSize: 12,
  },
});

export default memo(HoverOverView);
